<template>
  <!--  解决方案 -->
  <div class="">
    <HeaderTop />
    <MenuPage />

    <BannerDetail
      :backgroundImage="require('../assets/img/banner6.jpg')"
      :title="$t('solution.items[0].title')"
      :description="$t('solution.items[0].description')"
    />

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec1") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("Solutiondec7") }}</div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec2") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    <div class="solution-main">
      <div class="solution-box-two">
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec8") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec12") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec9") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec13") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec10") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec14") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec11") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec15") }}</div>
        </div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec3") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("Solutiondec337") }}</div>

        <div class="img-box">
          <img :src=" $t('image2') " class="img-li" />
        </div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec4") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-one">
          <img src="../assets/img/an1.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec17") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec20") }}</p>
        </div>
        <div class="item-one">
          <img src="../assets/img/an2.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec18") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec21") }}</p>
        </div>
        <div class="item-one">
          <img src="../assets/img/an3.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec19") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec22") }}</p>
        </div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec5") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>


     <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-two">
           <NumberCounter
                :label="$t('Solutiondec23')"
                :targetNumber="60"
                dec="%"
              />
        </div>
        <div class="item-two">
           <NumberCounter
                :label="$t('Solutiondec24')"
                :targetNumber="75"
                dec="%"
              />
        </div>
        <div class="item-two">
           <NumberCounter
                :label="$t('Solutiondec25')"
                :targetNumber="60"
                dec="%"
              />
        </div>
        <div class="item-two">
           <NumberCounter
                :label="$t('Solutiondec26')"
                :targetNumber="80"
                dec="%"
              />
        </div>
      </div>
    </div>


    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec6") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>


     <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-two">
           <img src="../assets/img/jie1.jpg"  class="item-two-img" />
          <div class="title-home-two">{{ $t("Solutiondec27") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec31") }}</p>
        </div>
        <div class="item-two">
           <img src="../assets/img/jie2.jpg" class="item-two-img"  />
          <div class="title-home-two">{{ $t("Solutiondec28") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec32") }}</p>
        </div>
       <div class="item-two">
           <img src="../assets/img/jie3.jpg" class="item-two-img"  />
          <div class="title-home-two">{{ $t("Solutiondec29") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec33") }}</p>
        </div>
        <div class="item-two">
           <img src="../assets/img/jie4.jpg"  class="item-two-img"   />
          <div class="title-home-two">{{ $t("Solutiondec30") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec34") }}</p>
        </div>
      </div>
    </div>

    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
import NumberCounter from "../components/NumberCounter.vue";
export default {
  components: { HeaderTop, MenuPage, BannerDetail,NumberCounter },
  name: "NewsPage",
  mounted() {
    this.scrollToTop();
  },
  data() {
    return {
      companyName: "",
      contactPerson: "",
      contactInfo: "",
      requirements: "",
    };
  },
  methods: {
     scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleSubmit() {
      // 阻止表单的默认提交行为
      alert("提交成功"); // 提示提交成功
      // 这里可以添加进一步的逻辑，比如将表单数据发送到服务器
      console.log({
        companyName: this.companyName,
        contactPerson: this.contactPerson,
        contactInfo: this.contactInfo,
        requirements: this.requirements,
      });
    },
  },
};
</script>
<style scoped>
</style>
